var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "m6.668 21.25 9.333 10.333L33.335 8.417"
  })));
};
export { SvgCheckMark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzc05hbWU9Im1iLTQiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aAogIGQ9Ik02LjY2Nzk3IDIxLjI1TDE2LjAwMTMgMzEuNTgzNEwzMy4zMzQ2IDguNDE2NjkiCiAgc3Ryb2tlPSIjMjUyNTI1IgogIHN0cm9rZS13aWR0aD0iMi41IgogIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIKICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIKLz4KPC9zdmc+";